<div class="PolicyDashboard">
    <div class="Loading" *ngIf="isShowLoading==true">
        <div class="loader"></div>
        <label class="loaderlabel">Please wait while Processing....</label>
    </div>
    <div class="container-fluid ">
        <div class="row">
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div class="col-md-12 proposals">
                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row Field">
                                <div class="col col-xs-12">
                                    <h3 class="panel-title">{{'Policy Information' | translate }}</h3>
                                </div>
                            </div>
                        </div>
                        <form #AddSeqform="ngForm">
                        <div class="panel-body">
                            <div class="PaymentForm">
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Policy Number' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtPolicyNo"
                                            id="txtPolicyNo" placeholder="{{objAddSeqReq.PolicyNo}}">
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Insured Name' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtName"
                                            id="txtName" placeholder="{{objAddSeqReq.InsuredName}}">
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Custom Id'| translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtCustomId"
                                            id="txtCustomId" placeholder="{{objAddSeqReq.CustomId}}">
                                    </div>
                                </div>

                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Chassis No'| translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtChassisNo"
                                            id="txtChassisNo" placeholder="{{objAddSeqReq.ChassisNo}}">
                                    </div>
                                </div>

                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Sequence No'| translate }}</label>
                                    </div>
                                    <!-- <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [(ngModel)]="objAddSeqReq.SequenceNo" name="txtSequence"
                                            id="txtSequence" >
                                    </div> -->
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input class="form-control" numbersOnly minlength="6" maxlength="9"
                                             pattern="^[0-9][0-9]{5,8}$"
                                            placeholder="{{'Sequence No'|translate}}" type="text" id="txtSeqNo"
                                            name="txtSeqNo" [(ngModel)]="objAddSeqReq.SequenceNo" #txtSeqNo="ngModel">
                                        <span *ngIf="txtSeqNo.errors && (txtSeqNo.dirty || txtSeqNo.touched)"
                                            class="text-danger valid">
                                            <p *ngIf="txtSeqNo.errors?.required">
                                                {{'Sequence No is required'| translate }}</p>
                                            <p *ngIf="txtSeqNo.errors?.pattern && txtSeqNo.invalid && txtSeqNo.touched">
                                                {{'Sequence No must be 6 to 9 digits' | translate }} </p>
                                        </span>

                                    </div>


                                </div>

                                <!-- <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <input class="form-control" numbersOnly minlength="6" maxlength="9"
                                        [required] pattern="^[0-9][0-9]{5,8}$"
                                        placeholder="{{'Sequence No'|translate}}" type="text" id="txtSeqNo"
                                        name="txtSeqNo" [(ngModel)]="newPolicyReq.SequenceNo" #txtSeqNo="ngModel">
                                    <span *ngIf="txtSeqNo.errors && (txtSeqNo.dirty || txtSeqNo.touched)"
                                        class="text-danger valid">
                                        <p *ngIf="txtSeqNo.errors?.required">
                                            {{'Sequence No is required'| translate }}</p>
                                        <p *ngIf="txtSeqNo.errors?.pattern && txtSeqNo.invalid && txtSeqNo.touched">
                                            {{'Sequence No must be 6 to 9 digits' | translate }} </p>
                                    </span>

                                </div> -->



                                <div class="btnUpdateSeqNo">
                                    <button class="btn btn-primary btnNext" name="btnNext" id="btnNext"
                                        (click)="UpdateSequenceNo()" [disabled]="(!AddSeqform.valid || objAddSeqReq.SequenceNo==null)">{{'Update Sequence'| translate }}</button>
                                </div>


                                <!-- OTP START -->

                                <!-- <div class="row Field" *ngIf="showOTP">
                                    <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12">
                                        <label class="Verifi">{{'Verification Code'|translate}}</label>
                                    </div>

                                    <div class="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                                        <input type="text" [(ngModel)]="otpReq.OTP" class="form-control" maxlength="6">
                                    </div>
                                    <div class="col-lg-2 col-md-6 col-sm-12 col-xs-12">
                                        <button type="button" class="btn btn-primary Resend"
                                            (click)="ProposalResendOTP()"
                                            *ngIf="isResendShow">{{'Resend'|translate}}</button>
                                        <button type="button" class="btn btn-primary Resend"
                                            (click)="ProposalVerifyOTP()"
                                            [disabled]="(otpReq.OTP?.length==0 || otpReq.OTP==null )">{{'Verify'|translate}}</button>
                                    </div>

                                </div>
                                <div class="Secondslbl" *ngIf="isShowTimer">
                                    <span class="quotelink">{{'You can Resend OTP in '}} <span
                                            class="time">{{ timeLeft }}</span>
                                        {{'Seconds'}}</span>
                                </div> -->
                                <!--  OTP END-->



                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/AddSequenceNo/AddSequenceNo.html